import { Store } from '../../../store/player/types';
import { persistAutoplay } from './persistAutoplay';

export const toggleAutoplay = (store: Store): void => {
  const { isAutoplaying, setAutoplay } = store.getState();

  setAutoplay(!isAutoplaying);
  persistAutoplay(store);
};
